import { render, staticRenderFns } from "./DriverDuration.vue?vue&type=template&id=bdeb80ea&scoped=true&"
import script from "./DriverDuration.vue?vue&type=script&lang=js&"
export * from "./DriverDuration.vue?vue&type=script&lang=js&"
import style0 from "./DriverDuration.vue?vue&type=style&index=0&id=bdeb80ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeb80ea",
  null
  
)

export default component.exports